import React, { useEffect, useState, useCallback } from "react";
import {
  Divider,
  Tooltip,
  Typography,
  IconButton,
  Badge,
  Grid,
} from "@material-ui/core";
import Modal from "../../cm_shared/cm_global_modal";
import axios from "axios";
import DataTable from "react-data-table-component";
import { NoteAdd as NoteAddIcon } from "@material-ui/icons";
import ScenarioGroupingFlow from "../ScenarioGroupingFlow";
import options from "./options";
import CustomPagination from "../../cm_shared/CMCustomPagination";
import { Link } from "react-router-dom";
import CMDeleteModal from "../../cm_shared/CMDeleteModal";
import PGScenarioLogicalNameListing from '../OpenLoopListing/PGScenariosLogicalBased/index'
const parseJSONString = (str) => {
  try {
    return JSON.parse(str.replace(/'/g, '"'));
  } catch (error) {
    return str;
  }
};

const customStyles = {
  table: {
    style: {
      border: "solid 1px rgba(0,0,0,.2)",
      borderRadius: "10px",
    },
  },
  rows: {
    style: {
      minHeight: "72px",
      cursor: "pointer",
      fontSize: 16,
      paddingTop: "10px",
      paddingBottom: "10px",
    },
  },
  headCells: {
    style: {
      paddingLeft: "8px",
      paddingRight: "8px",
      backgroundColor: "#b0ff45",
      justifyContent: "center",
    },
  },
  cells: {
    style: {
      paddingLeft: "8px",
      paddingRight: "8px",
      fontWeight: "bold",
      justifyContent: "center",
    },
  },
};

function PRDataSubtableListing(props) {
  console.log('subTable', props);
  const [loading, setLoading] = useState(false);
  const [scenarioCollectionNew, setScenarioCollectionNew] = useState([]);
  const initialColumns = [
    {
      name: "Data Segment",
      selector: "data_segment",
      sortable: false,
      reorder: false,
    },
    {
      name: "Category",
      selector: "category",
      sortable: false,
      reorder: false,
    },
    {
      name: "Hypo Classes",
      selector: "hypo_classes",
      sortable: false,
      reorder: false,
    },
    {
      name: "Hypo Type",
      selector: "hypo_type",
      sortable: false,
      reorder: false,
    }
  ];
  
  const fetchScenarioCollectionNew = async () => {
    try {
      setLoading(true);
      const response = await axios.get(
        `http://localhost:3010/pg_data_sub_table_listing?pg_data_id=${props.data.id}`,
      );
      console.log('pgDataSubtable', response);
      setScenarioCollectionNew(response.data);
    } catch(error) {
      console.log(error)
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchScenarioCollectionNew()
  }, [])

  const handleRowClick = (row,e) => {
    console.log("row E",row,e);
    window.location.href = "/pr_data_subtable_resimulation_history/"+row.id
  }

  return (
    <div
      style={{
        padding: "1rem",
        position: "relative",
        background: "white",
        margin: "30px",
        borderRadius: "10px",
      }}
    >
      <div style={{ overflowX: "auto" }}>
        {loading === false && initialColumns.length > 0 ? (
          <DataTable
            columns={initialColumns}
            data={scenarioCollectionNew}
            customStyles={customStyles}
            progressPending={loading}
            loading={loading}
            onRowClicked={handleRowClick}
          ></DataTable>
        ) : null}
      </div>
    </div>
  );
}

export default PRDataSubtableListing;
